(function () {
  document.querySelectorAll('[data-event-inquiry-fields]').forEach(function (fields) {
    var planner = fields.querySelector('[data-planner-select]');
    var nameGroup = fields.querySelector('[data-planner-name]');
    function updatePlanner() {
      var active = !planner.disabled && planner.value === 'Yes';
      nameGroup.hidden = !active;
      nameGroup.querySelector('input').disabled = !active;
    }
    planner.addEventListener('change', updatePlanner);
    fields.closest('form').addEventListener('avant:department-change', updatePlanner);
    updatePlanner();
  });
})();
